import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogContent } from '@angular/material/dialog';
import { CasoDeUsoBean } from 'src/app/shared/casosDeUso';
import { HistoriaDeUsuario } from 'src/app/shared/historiaUsuario';
import { EpicasBean } from 'src/app/shared/model/gestion-proyectos/epicas.model';
import { TareaHuCu } from 'src/app/shared/model/gestion-proyectos/tareasCuHu';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { NgIf } from '@angular/common';
import { ModalHuComponent } from '../modal-hu/modal-hu.component';
import { ModalEpicasComponent } from '../modal-epicas/modal-epicas.component';
import { ModalCuComponent } from '../modal-cu/modal-cu.component';
import { ModalTaskComponent } from '../modal-task/modal-task.component';
import { DiscusionesComponent } from '../dicusiones/dicusiones.component';

@Component({
    selector: 'app-consulta-casos-de-uso',
    templateUrl: './consulta-casos-de-uso.component.html',
    styleUrls: ['./consulta-casos-de-uso.component.css'],
    imports: [MatIconButton, MatIcon, CdkScrollable, MatDialogContent, NgIf, ModalHuComponent, ModalEpicasComponent, ModalCuComponent, ModalTaskComponent, DiscusionesComponent]
})
export class ConsultaCasosDeUsoComponent {
  esEpica: boolean = false;
  esCasoDUso: boolean = false;
  esHistoriaUsuario: boolean = false;
  esTarea: boolean = false;
  objetoEpicas: EpicasBean;
  objetoCasosDeUso: CasoDeUsoBean;
  objetoHistoriaUsuario: HistoriaDeUsuario;
  objetoTask: TareaHuCu;
  agregar: string;


  constructor(public dialogRef: MatDialogRef<ConsultaCasosDeUsoComponent>, @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit() {
    if (this.data !== null && this.data !== undefined) {
      if (this.data.clase === 'HU') {
        this.objetoHistoriaUsuario = new HistoriaDeUsuario();
        this.agregar = "Historia de usuario";
        this.esHistoriaUsuario = true;
      } else if (this.data.clase === 'EPICA') {
        this.objetoEpicas = new EpicasBean();
        this.agregar = "Épica";
        this.esEpica = true;
      } else if (this.data.clase === 'CU') {
        this.objetoCasosDeUso = new CasoDeUsoBean();
        this.agregar = "Caso de uso";
        this.esCasoDUso = true;
      } else if (this.data.clase === 'TAREA') {
        this.objetoTask = new TareaHuCu();
        this.agregar = "Tarea";
        this.esTarea = true;
      } else {
        console.warn('Tipo seleccionado no reconocido:', this.data);
      }
    }
  }

  onNoClick(): void {
    this.dialogRef.close();

  }



}
